import React from 'react';
import ActionButton from "./ActionButton";
import { useLingui } from '@lingui/react/macro';

function ModalFooter(props) {
    const {t} = useLingui();
    return (
        <div className="p-4 flex justify-end">
            {props.onCancel &&
            <button className="cursor-pointer underline text-primary mr-4" onClick={props.onCancel}>
                {props.cancelLabel || t({id: "cancel"})}
            </button>
            }

            <ActionButton
                classes="px-4"
                disabled={props.actionDisabled}
                buttonText={props.actionButtonText}
                onClick={props.onActionClick}
            />
        </div>
    );
}

export default ModalFooter;